<template>
  <v-card height="300px">
    <v-card-title>
      <div class="text--center">
        <img
          :src="getThumbnailUrl(image.assets.tn200x200.href)"
          height="175px"
          contain
        />
      </div>
      <v-chip>{{ image.id }}</v-chip>
    </v-card-title>

    <v-card-text heigth="200px" class="overflow-y-auto">
      <h5 v-if="image.properties['caption/abstract']">Caption:</h5>
      <p v-if="image.properties['caption/abstract']">
        {{
          image.properties["caption/abstract"].length > 100
            ? image.properties["caption/abstract"].substring(0, 100) + "..."
            : image.properties["caption/abstract"]
        }}
      </p>
      <v-divider></v-divider>
      <!-- <h5>General information:</h5>
      <p v-if="image != null">
        {{ "By-line: " + image.properties["by-line"] }}
      </p>
      <p v-if="image != null">
        {{ "Credit: " + image.properties["credit"] }}
      </p>
      
      <v-divider></v-divider> -->
      <h5>Datetime:</h5>
      <p v-if="image != null">
        {{
          new Date(image.properties.datetime).toDateString() +
          ", " +
          new Date(image.properties.datetime).toTimeString()
        }}
      </p>

      <!-- <p v-if="sample_data != null">
        {{
          "Coordinates: " +
          sample_data.properties.latitude +
          "° N, " +
          sample_data.properties.longitude +
          "° E"
        }}
      </p>
      <p v-if="sample_data != null">
        {{
          "Archive: " +
          sample_data.properties.archive +
          "; Proxy: " +
          sample_data.properties.proxy
        }}
      </p>
      <p v-if="sample_data != null">
        {{
          "Authors: " +
          (sample_data.properties.pub.author.length > 1
            ? sample_data.properties.pub.author.slice(0, 1) + " et al."
            : sample_data.properties.pub.author.slice(0, 1))
        }}
      </p> -->
    </v-card-text>
    <v-card-actions>
      <v-btn-toggle>
        <v-btn
          small
          target="_blank"
          rel="noopener noreferrer"
          :href="getOriginalUrl(image.id)"
          >Fullscreen</v-btn
        >
        <!-- <v-spacer></v-spacer
      > -->
        <v-btn small dark color="black" class="downloadimage">Download</v-btn>

        <v-btn small color="primary" class="opendialog">Details</v-btn>
      </v-btn-toggle>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
const HOST_ORIGINAL = process.env.VUE_APP_ORIGINAL_PHOTOS;
const HOST_THUMBNAILS = process.env.VUE_APP_THUMBNAILS;
export default {
  name: "CustomPopup",
  props: ["feature"],
  data: function () {
    return {
      image: this.feature,
    };
  },
  methods: {
    getThumbnailUrl(path) {
      return HOST_THUMBNAILS + path;
    },
    getOriginalUrl(path) {
      return HOST_ORIGINAL + path + ".jpg";
    },
    downloadImage(iurl) {
      axios({
        url: iurl, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", iurl.split("/").pop()); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>

<style>
</style>